import { WALLET_ACTION } from '../../constants/actions'

const getWallet = (address) => ({
  type: WALLET_ACTION.ON_GET_WALLET,
  payload: { address }
})

export { getWallet }
